// @ts-nocheck
import React from "react";
import {
  Tooltip,
  IconButton,
  Menu,
  MenuItem,
  Box,
  Popover,
} from "@material-ui/core";
import FilterListIcon from "@material-ui/icons/FilterList";
import Checkbox from "@material-ui/core/Checkbox";

const status = [
  {
    name: "activated",
  },
  {
    name: "not activated",
  },
  {
    name: "expired",
  },
  {
    name: "suspended",
  },
];

const days = [
  {name: "1"},
  {name: "5"},
  {name: "10"},
  {name: "30"},
  {name: "60"},
];

const type = [{name: "demo"}, {name: "regular"}];

const POPOVER_STYLES = {
  anchorOrigin: {
    vertical: "top",
    horizontal: "right",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left",
  },
};

const MENU_ITEM_STYLES = {
  textTransform: "capitalize",
  fontSize: "16px",
  margin: "4px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

const DropDown = ({
  filters,
  setFilters,
  insallations,
  insallationsIds,
  setInsallationsIds,
  userRole,
}) => {
  const [openMenu, setOpenMenu] = React.useState(null);
  const [openStatusMenu, setOpenStatus] = React.useState(null);
  const [openDaysMenu, setOpenDaysMenu] = React.useState(null);
  const [openTypeMenu, setOpenTypeMenu] = React.useState(null);
  const [openInsallationsMenu, setOpenInsallationsMenuu] = React.useState(null);

  const openStatus = Boolean(openStatusMenu);
  const openDays = Boolean(openDaysMenu);
  const openType = Boolean(openTypeMenu);
  const openInsallation = Boolean(openInsallationsMenu);

  const handleChange = (event, key) => {
    event.stopPropagation();
    if (!filters.hasOwnProperty(key)) {
      filters[key] = [];
    }
    const checked = filters[key].includes(event.target.value);
    const uncheck = filters[key].filter((item) => item !== event.target.value);

    return checked
      ? setFilters({...filters, [key]: [...uncheck]})
      : setFilters({
          ...filters,
          [key]: [...filters[key], event.target.value],
        });
  };

  const handlerType = (event, key) => {
    event.stopPropagation();
    if (!filters.hasOwnProperty(key)) {
      filters[key] = null;
    }

    const checked = filters[key]?.includes(event.target.value);

    return checked
      ? setFilters({...filters, [key]: null})
      : setFilters({...filters, [key]: event.target.value});
  };

  const handlerEnvironment = (event, id) => {
    event.stopPropagation();

    const checked = insallationsIds.includes(id);

    return checked
      ? setInsallationsIds(insallationsIds.filter((ids) => ids !== id))
      : setInsallationsIds([...insallationsIds, id]);
  };

  return (
    <>
      <Tooltip title="Filters">
        <IconButton
          color={Object.keys(filters).length > 0 ? "primary" : "default"}
          onClick={(event) => setOpenMenu(event.target)}
        >
          <FilterListIcon />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={openMenu}
        open={Boolean(openMenu)}
        onClose={() => setOpenMenu(null)}
      >
        <MenuItem onClick={(event) => setOpenStatus(event.currentTarget)}>
          Status
        </MenuItem>
        <Popover
          open={openStatus}
          anchorEl={openStatusMenu}
          onClose={() => setOpenStatus(null)}
          anchorOrigin={POPOVER_STYLES.anchorOrigin}
          transformOrigin={POPOVER_STYLES.transformOrigin}
        >
          {status.map((item) => (
            <Box key={item.name} style={{...MENU_ITEM_STYLES}}>
              {item.name}
              <Checkbox
                value={item.name}
                checked={filters.status_in?.indexOf(item.name) > -1}
                onChange={(e) => handleChange(e, "status_in")}
                color="primary"
                disabled={
                  filters.status_in?.length >= 2 &&
                  !filters.status_in?.includes(item.name)
                }
              />
            </Box>
          ))}
        </Popover>
        <MenuItem onClick={(event) => setOpenDaysMenu(event.currentTarget)}>
          Days left
        </MenuItem>
        <Popover
          open={openDays}
          anchorEl={openDaysMenu}
          onClose={() => setOpenDaysMenu(null)}
          anchorOrigin={POPOVER_STYLES.anchorOrigin}
          transformOrigin={POPOVER_STYLES.transformOrigin}
        >
          {days.map((item) => (
            <Box key={item.name} style={{...MENU_ITEM_STYLES}}>
              {item.name}
              <Checkbox
                value={item.name}
                checked={filters.days_left_in?.indexOf(item.name) > -1}
                onChange={(e) => handleChange(e, "days_left_in")}
                color="primary"
              />
            </Box>
          ))}
        </Popover>
        <MenuItem onClick={(event) => setOpenTypeMenu(event.currentTarget)}>
          Type
        </MenuItem>
        <Popover
          open={openType}
          anchorEl={openTypeMenu}
          onClose={() => setOpenTypeMenu(null)}
          anchorOrigin={POPOVER_STYLES.anchorOrigin}
          transformOrigin={POPOVER_STYLES.transformOrigin}
        >
          {type.map((item) => (
            <Box key={item.name} style={{...MENU_ITEM_STYLES}}>
              {item.name}
              <Checkbox
                value={item.name}
                checked={
                  filters.type ? filters.type.includes(item.name) : false
                }
                onChange={(e) => handlerType(e, "type")}
                color="primary"
                disabled={
                  filters.type?.length > 0 && !filters.type?.includes(item.name)
                }
              />
            </Box>
          ))}
        </Popover>
        {userRole === "admin" && (
          <>
            <MenuItem
              onClick={(event) => setOpenInsallationsMenuu(event.currentTarget)}
            >
              Environment
            </MenuItem>
            <Popover
              open={openInsallation}
              anchorEl={openInsallationsMenu}
              onClose={() => setOpenInsallationsMenuu(null)}
              anchorOrigin={POPOVER_STYLES.anchorOrigin}
              transformOrigin={POPOVER_STYLES.transformOrigin}
            >
              {insallations.map((item) => (
                <Box key={item.id} style={{...MENU_ITEM_STYLES}}>
                  {item.name}
                  <Checkbox
                    value={item.name}
                    checked={insallationsIds.includes(item.id)}
                    onChange={(e) => handlerEnvironment(e, item.id)}
                    color="primary"
                    disabled={
                      insallationsIds.length === 1 &&
                      insallationsIds.includes(item.id)
                    }
                  />
                </Box>
              ))}
            </Popover>
          </>
        )}
      </Menu>
    </>
  );
};

export default DropDown;
